export default {
  displayTime (time) {
    return time === Infinity ? 'DNF' : (isNaN(time) ? '-' : this.displayMillis(time))
  },
  displayTimeWithMetadata(time) {
    return (time.metadata === 'ok' || time.metadata === '+2' ? (this.displayMillis(time.time) + (time.metadata === '+2' ? '+' : '')) : time.metadata === 'dnf' ? 'DNF' : (time.metadata === 'dns' ? 'DNS' : (time.metadata === 'dq' ? 'DQ' : time.metadata)))
  },
  displayMillis (millis) {
    const ms = (millis % 1000).toString().padStart(3, '0')
    millis = Math.trunc(millis / 1000)
    let s = millis % 60
    millis = Math.trunc(millis / 60)
    let m = millis % 60
    millis = Math.trunc(millis / 60)
    let h = millis

    m = h ? ':' + m.toString().padStart(2, '0') : m
    s = m ? ':' + s.toString().padStart(2, '0') : s

    return `${h || ''}${m || ''}${s}.${ms}`
  },
  roundNameSuffix (roundID) {
    try {
      let [, num] = roundID.split('R')
      if (num === 'qual') return 'Qualifiers'
      num = parseInt(num)
      if (num === 2) return 'Finals'
      if (num === 4) return 'Semi-Finals'
      if (num === 8) return 'Quarter-Finals'
      return `Round of ${num}`
    } catch (e) {
      // TODO: remove this catch all exception that's being used to catch Array IndexOutOfBounds errors
      return ''
    }
  }
}
